import { Component, OnInit, Inject } from "@angular/core";
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { locale as english } from './i18n/en';
import { locale as dutch } from './i18n/nl';
import { AppConfig } from '../../core/configs/app-config';
import { HttpClient,  } from '@angular/common/http';
import { MatDialog} from '@angular/material/dialog';
import { Router } from '@angular/router';
import {MedewerkerPlanning} from '../../model/dto/medewerkers/overzicht';
import {PlanningOverzicht} from '../../model/dto/planning/overzicht';
import {formatDate} from '@angular/common';
import 'fullcalendar';
import 'fullcalendar-scheduler';
import * as jQuery from "jquery";
import {UserService } from "../../core/services/user.service";
import { PlanningKlantGegevensDialog } from '../planningoverzichtsimpel/planningKlantGegevens/planningKlantGegevensDialog';

(window as any).$ = (window as any).jQuery = jQuery;
declare let $: any;

@Component({
    selector   : 'home',
    templateUrl: './home.component.html',
    styleUrls  : ['./home.component.scss']
})
export class HomeComponent implements OnInit
{

     config: any;
     Medewerkers: MedewerkerPlanning[] = [];
     PlanningOverzicht: PlanningOverzicht[] = [];
     selectedAfdelingen: any[] = [];
     cbChecked : boolean;
     aantaldagen : number = 7;
     datetot: Date;
     datebegin: Date;
     loading: boolean = false;

     constructor(private router: Router, public dialog: MatDialog, private _fuseTranslationLoaderService: FuseTranslationLoaderService, private userService:UserService, @Inject(HttpClient) private http?: HttpClient)
     {
         this.config = {
             "SERVERPROTOCOL": AppConfig.ApiProtocol,
             "SERVERURL": AppConfig.ApiLoginHost,
             "SERVERPORT": AppConfig.ApiPort,
             "APPLICATIONID": AppConfig.ApiApplicationId,
             "METHOD": AppConfig.ApiMethod,
             "LOGINURL": AppConfig.ApiLoginUrl,
             "STACKURL": AppConfig.ApiUrl
           };
         this._fuseTranslationLoaderService.loadTranslations(english, dutch);
 
     }

     ngOnInit() {
        this.reloadSheduler();
      }

      reloadSheduler(){
        $('#calendar').fullCalendar('destroy');
        this.PlanningOverzicht = [];
    
        this.cbChecked = true;
    
        this.datetot = new Date();
        this.datetot.setDate( this.datetot.getDate() + this.aantaldagen );
        this.datebegin = new Date();
        this.datebegin.setDate( this.datebegin.getDate());
    
     
    
       let conString = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/planning/overzicht/" + formatDate(this.datebegin, 'dd-MM-yyyy', 'en') + "/"+ formatDate(this.datetot, 'dd-MM-yyyy', 'en') + "/" + this.userService.getCurrentUser().MedewerkerID;
    
        var get = this.http.get(conString);
        get.subscribe(     
        (results:any) => {
        for (var result of  results){ 
  
          var title = "";
          if (result["BedrijfAfkorting"] == "Nr0") {
            title = result["Categorie"] + " " + result["Onderwerp"];      
          } else {
            title = result["BedrijfAfkorting"] + " " + result["Onderwerp"];
          }
          this.PlanningOverzicht.push({ id:result["PlanningID"], resourceId:result["MedewerkerID"], start:result["Start"],end:result["Tot"],title:title, patroon:result["Patroon"], onderwerpID:result["onderwerpID"]});
        }  
    
        $('#calendar').fullCalendar({
          aspectRatio: 1,
          scrollTime: '00:00', // undo default 6am scrollTime
          header: {
            left: '',
            center: 'title',
            right: '' 
              //...other buttons
         },
         height: 400,
         weekNumbers: true,
         weekNumberCalculation: "ISO",
          defaultView: 'listWeek',
          views: {
            listWeek: {
              type: 'listWeek',
              duration: { days: this.aantaldagen }
            }
          },
          eventRender : function(event, element) {
            element[0].title = event.title;
         },
         
          events:this.PlanningOverzicht,eventClick: (calEvent, jsEvent, view) => {
  
            const dialogRef = this.dialog.open(PlanningKlantGegevensDialog, {
              maxHeight: '100vh',
              disableClose: true,
              data: {calEvent: calEvent, onlyToday: true}
            });
          
           
            $(this).css('border-color', 'red');
       
           },
          schedulerLicenseKey: 'GPL-My-Project-Is-Open-Source',
          slotDuration: '24:00'
        });
        
        },
        (error) => {
        console.error(error);
        });
        
      }

      updateMedewerkers(){

        var body = {
         "AfdIDs": this.selectedAfdelingen,
         "InplanbareMedewerker": true
        };
   
   
       let conString = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/planning/medewerkersoverzicht";
   
       var post = this.http.post(conString, body);
       post.subscribe(     
       (results: any) => {
         this.Medewerkers.length = 0;
       for (var result of  results){ 
         if (result["MedewerkerID"] == this.userService.getCurrentUser().MedewerkerID) {
           this.Medewerkers.push({ id:result["MedewerkerID"], title:result["CplNaam"], afdeling:"services"});
         }
       }  
   
       $('#calendar').fullCalendar("refetchResources");
       },
       (error) => {
       console.error(error);
       });
       
       }
}
